export default __webpack_public_path__ + "static/media/authIllustration.fb10520f.svg";